export default __webpack_public_path__ + "static/media/DSC05336.39a56bb9.JPG";